import type { EnabledTabs, RewardCenterTab } from "../../types";

const isTabEnabled = (
  enabledTabs: EnabledTabs | undefined,
  tab: RewardCenterTab,
): boolean => tab === "rewards" || enabledTabs?.[tab] === true;

export default isTabEnabled;
